<!--  -->
<template>
  <div class="dsawr">
    <div>
      <div class="accopunr_list">
        <div class="accopunr_list">
          <!-- <div>账号类型：</div> -->
          <el-input v-model="pageIfon.app_id" placeholder="请输入app_id" style="margin-right:10px;width:200px" />
          <el-input v-model="pageIfon.open_id" placeholder="请输入open_id" style="margin-right:10px;width:200px" />
          <el-button type="primary" icon="el-icon-search" @click="(pageIfon.page = 1),exchangedata()">搜索</el-button>
          <el-button type="info" icon="el-icon-refresh" @click="reset">重置</el-button>
        </div>

      </div>

    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      max-height="500"
    >
      <el-table-column
        prop="app_id"
        label="app_id"
        width="300"
        align="center"
      />
      <el-table-column
        prop="open_id"
        label="open_id"
        width="300"
        align="center"
      />
      <el-table-column
        prop="report_type"
        label="举报类型 "
        align="center"
        width="300"
      />
      <el-table-column
        prop="report_content"
        label="举报内容"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            placement="top"
            popper-class="limited-tooltip"
          >
            <template #content>
              <div class="tooltip-content">{{ scope.row.report_content }}</div>
            </template>

            <div class="ellipsis-text">
              {{ scope.row.report_content }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        prop="create_at_text"
        label="过期时间"
        align="center"
      >
        <template slot-scope="scope">
          <div>{{ scope.row.create_at_text }}</div>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { articleSettinguserReportList } from '@/api/bserw.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      tableData: [],
      total: null,
      pageIfon: {
        page: 1,
        page_size: 10,
        app_id: '',
        open_id: ''
      },
      // options: [{
      //   value: 1,
      //   label: '三天后过期'
      // }, {
      //   value: 2,
      //   label: '七天后过期'
      // }, {
      //   value: 3,
      //   label: '过期7天内'
      // }, {
      //   value: 4,
      //   label: '已过期'
      // }],
      loading: false
    }
  },
  created() {
    this.exchangedata()
  },
  mounted() {

  },
  methods: {
    async exchangedata() {
      this.loading = true
      const data = await articleSettinguserReportList(this.pageIfon)
      this.loading = false
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.exchangedata()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.exchangedata()
    },
    // 重置
    reset() {
      this.pageIfon = {
        page: 1,
        page_size: 10,
        app_id: '',
        open_id: ''
      }
      this.exchangedata()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dsawr{
  padding: 20px;
}
.accopunr_list{
  display:flex;
  align-items: center;
  margin-bottom:10px
}
.activer{
  color: red;
}
.activerno{
  color: #67C23A;
}
/* 表格中只显示一行，超出省略 */
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 260px;
}

/* tooltip 内容限制宽高，避免太长太占位 */
.el-tooltip__popper.limited-tooltip {
  max-width: 400px;
  max-height: 150px;
  overflow: auto;
  white-space: normal;
  word-break: break-all;
  padding: 10px;
  font-size: 14px;
}

.tooltip-content {
  line-height: 1.5;
}
</style>
